module.exports = __webpack_public_path__ + "img/card-workshop-hover.4882b4fe.svg";